export const API_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://api.klasserooster.nl'
    : 'http://localhost:8080';
